import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
  hideBackground: PropTypes.bool,
  isRound: PropTypes.bool
};

const defaultProps = {
  hideBackground: false,
  isRound: false
};

function Avvo(props) {
  const { hideBackground, isRound, ...rest } = props;

  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...rest}>
      {!hideBackground && <rect fill="#0C4277" height="24" rx={isRound ? '100%' : 0} width="24" />}
      <path
        d="M18 17.3124H15.0159C14.9757 16.7994 14.9254 16.2931 14.9053 15.7869C14.8919 15.465 14.7645 15.3275 14.4359 15.3275C13.0377 15.3376 11.6396 15.3208 10.2448 15.3443C10.0805 15.3443 9.85583 15.5019 9.77536 15.6494C9.5373 16.0819 9.36295 16.5513 9.14837 16.9972C9.08466 17.128 8.9606 17.3191 8.86002 17.3225C7.93462 17.3459 7.00922 17.3359 6 17.3359C6.12741 16.9939 6.21459 16.7257 6.32858 16.4675C7.81391 13.0945 9.83236 10.0936 12.679 7.69968C13.5541 6.96204 14.5163 6.35852 15.6496 6.08023C15.7871 6.0467 15.9313 6.01988 16.0721 6.01317C16.974 5.96288 17.0008 6.01653 17.0746 6.90504C17.2422 8.88325 17.4468 10.8615 17.6245 12.8397C17.7586 14.3216 17.8726 15.8036 17.9966 17.3124H18ZM14.3956 9.3493C13.1048 10.4155 12.2028 11.6058 11.3177 12.9335H14.6605L14.3956 9.3493Z"
        fill="white"
      />
    </svg>
  );
}

Avvo.propTypes = propTypes;
Avvo.defaultProps = defaultProps;

export default Avvo;
